import axios from "axios";
import React from "react";
import HeaderLogic from "./HeaderLogic";
import "../../css/style.css";
import HeaderDesktop from "./HeaderDesktop";
import { useEffect } from "react";
import { setSecureCookie, setCookie, getCookie, clearAuthCookies } from "../../utils/cookieUtils";

const Header = () => {
  const { symbolData } = HeaderLogic();

  const getAccessToken =
    "https://6zqeqxesw2.execute-api.ap-south-1.amazonaws.com/default/getV2AccessToken";

  const generateAccessToken = async (auth_code, user_id) => {
    try {
      const body = {
        authCode: auth_code,
        userId: user_id,
      };
      const response = await axios.post(getAccessToken, body);
      let settingData = response.data;
      return settingData;
    } catch (error) {
      console.error("Error fetching settings:", error);
      return null;
    }
  };

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("verifiedpnl")) {
      window.location.replace(
        window.location.href.replace("dashboard", "beta")
      );
    }
  }, []);

  //for automatically logging out if date doesn't match
  useEffect(() => {
    const storedDate = getCookie("login_date");
    const currentDate = new Date().toLocaleDateString();
    if (storedDate !== currentDate && storedDate != null) {
      clearAuthCookies();
      window.location.href = "https://1lyoptions.com/";
    }
  }, []);

  useEffect(() => {
    const run = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const auth_code = urlParams.get("authCode");
      const user_id = urlParams.get("userId");
      const page = urlParams.get("page");
      const broker = urlParams.get("broker");
      const client_id = urlParams.get("client_id");
      const access_token = urlParams.get("access_token");
      const name = urlParams.get("name");
      const basket = urlParams.get("basket");

      const currentDate = new Date().toLocaleDateString();
      if (broker == "gmail") {
        setCookie("broker", broker);
        setSecureCookie("user_id", user_id);
        setSecureCookie("access_token", access_token);
        setSecureCookie("client_id", client_id);
        setCookie("login_date", currentDate);
        setCookie("name", name);
        window.location.replace("https://dashboard.1lyoptions.com/");
      } else {
        let response = await generateAccessToken(auth_code, user_id);
        if (response?.body) {
          setCookie("login_date", currentDate);
          setSecureCookie("access_token", response?.body.access_token);
          setSecureCookie("client_id", user_id);
          setSecureCookie("ws_token", response?.body.ws_access_token);
          setSecureCookie("user_id", user_id);
          setCookie("broker", "aliceblue");
          setCookie("auth_code", auth_code);
          if (page == "position") {
            window.location.replace(
              "https://dashboard.1lyoptions.com/positions"
            );
          } else if (basket) {
            window.location.replace(
              "https://dashboard.1lyoptions.com/?basket=" + basket
            );
          } else {
            window.location.replace("https://dashboard.1lyoptions.com/");
          }
        } else {
          // console.log("Auth code not found.");
        }
      }
    };

    run();
  }, []);

  return <HeaderDesktop symbolData={symbolData} />;
};

export default Header;
